import PropTypes from 'prop-types';
import { useRef } from 'react';

import Sidebar from 'components/Sidebar';
import FeaturedOffersList from 'components/Sidebar/FeaturedOffersList';
import TopContributorsCommentsRanking from 'components/TopContributorsCommentsRanking';

const LastCommentsSidebar = ({
  commentsSourceName,
  sidebarFeaturedOffers = [],
}) => {
  const lastCommentsTopContributorsRankingRef = useRef(null);
  const featuredOffersListRef = useRef(null);

  return (
    <Sidebar
      className="space-y-4"
      refsToBeIgnoredBeforeFixing={[
        lastCommentsTopContributorsRankingRef,
        featuredOffersListRef,
      ]}
    >
      <TopContributorsCommentsRanking
        ref={lastCommentsTopContributorsRankingRef}
        commentsSourceName={commentsSourceName}
        gaEventCategory="last_comments_contributors"
      />
      <FeaturedOffersList
        ref={featuredOffersListRef}
        featuredOffers={sidebarFeaturedOffers}
      />
    </Sidebar>
  );
};

LastCommentsSidebar.propTypes = {
  commentsSourceName: PropTypes.string.isRequired,
  sidebarFeaturedOffers: PropTypes.arrayOf(
    PropTypes.shape({
      offerId: PropTypes.number.isRequired,
      offerTitle: PropTypes.string.isRequired,
      offerPrice: PropTypes.number.isRequired,
      offerOldPrice: PropTypes.number,
      offerPriceType: PropTypes.string.isRequired,
      offerPhoto: PropTypes.string.isRequired,
      offerSlug: PropTypes.string.isRequired,
    })
  ),
};

export default LastCommentsSidebar;
